import { render } from "./EmployeeDocumentsUpload.vue?vue&type=template&id=1f7dd154&scoped=true"
import script from "./EmployeeDocumentsUpload.vue?vue&type=script&lang=js"
export * from "./EmployeeDocumentsUpload.vue?vue&type=script&lang=js"

import "./EmployeeDocumentsUpload.vue?vue&type=style&index=0&id=1f7dd154&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f7dd154"]])

export default __exports__